import { useMutation } from "@tanstack/react-query";
import { getErrorStatusCode } from "../../../../api/api-response";
import { RestEndpoints } from "../../../../api/endpoints";
import getInstance, { instanceOfAxiosError } from "../../../../utils/rest";
import { IPomSubmitReportingModel } from "../../../models/reportings/pom-submit-reporting.model";

export interface ISubmitReportingResult {
  status: number;
  errorMessage?: string;
}

const submitReporting = async (
  contractNo: string,
  reportingNo: number,
  request: IPomSubmitReportingModel,
): Promise<ISubmitReportingResult> => {
  try {
    const result = await getInstance().post(
      `${RestEndpoints.PomReportings}/${contractNo}/${reportingNo}/submit`,
      request,
    );
    return { status: result.status };
  } catch (error: unknown) {
    const code = getErrorStatusCode(error);
    const errorMessage = instanceOfAxiosError(error) ? (error.response?.data as { message?: string })?.message : undefined;
    return { status: code, errorMessage };
  }
};

export const useSubmitReportingMutation = () => {
  return useMutation({
    mutationFn: ({
      contractNo,
      reportingNo,
      request,
    }: {
      contractNo: string;
      reportingNo: number;
      request: IPomSubmitReportingModel;
    }) => submitReporting(contractNo, reportingNo, request),
  });
};
